import { BasicSoundController, PathProvider } from "@goodgamestudios/core";
import { SoundChannel, SoundService } from "@goodgamestudios/createjs-utilities";
import { Constants } from "../constants/shared/Constants";

export class Poker2SoundController extends BasicSoundController {
    /**
     *
bonk		1	keine funktion für gast win0300
buddy		1	Wenn man eine Freundschaftsanfrage bekommt
!call		2	Call (im Spiel)
!check		2	Check (im Spiel)
!chips		1	Wenn die Chips gehen zum Gewinner
! click		1	Klick auf Knöpfe
!flop		1	Die "Community Cards" werden aufgedeckt
!fold		2	Fold (im Spiel)
!gift		2	Wen man ein Geschenk gesendet hat
inactive		wenn man auf einem inaktiven Knopf oder Item anklickt  <--- die sind nicht anklickbar deshalb bekomme ich das auch nicht mit
!late			Zeit ist verlaufen.
!lose			Wenn man alles, was er am Tisch hat, verliert
move			Wenn die Fenster sich bewegen oder ändern
pause			in der Pause zwischen den Runden
pop				Wenn eine Sprechblase erscheint
!pot			1	wenn die Wetten in dem Pott gesammelt werden
!raise		2	Raise (im Spiel)
!spread		1	Cards werden verteilt
!time		1	Wenn man dran ist aber hat noch nicht gewettet, nach der halben zeit.
!turn		1	Wenn man dran ist
!up				Wenn man ein Level Up oder ein Achievement bekommt
warn		x	Wenn man ein Meldung-Fenster bekommt (AlertGast, AlertLevel)
!win			1	Wenn man gewinnt
!xp			1	Wenn man XP Punkte bekommt (AlertAchievement?)
        */
    public static SND_CLICK: string = "click_mp3";
    public static SND_BONK: string = "bonk_mp3";
    public static SND_BUDDY: string = "buddy_mp3";
    public static SND_CALL: string = "call_mp3";
    public static SND_CHECK: string = "check_mp3";
    public static SND_CHIPS: string = "chips_mp3";
    public static SND_FLOP: string = "flop_mp3";
    public static SND_FOLD: string = "fold_mp3";
    public static SND_GIFT: string = "gift_mp3";
    public static SND_INACTIVE: string = "inactive_mp3";
    public static SND_LATE: string = "late_mp3";
    public static SND_LOSE: string = "lose_mp3";
    public static SND_MOVE: string = "move_mp3";
    public static SND_PAUSE: string = "pause_mp3";
    public static SND_POP: string = "pop_mp3";
    public static SND_POT: string = "pot_mp3";
    public static SND_RAISE: string = "raise_mp3";
    public static SND_SPREAD: string = "spread_mp3";
    public static SND_TIME: string = "time_mp3";
    public static SND_TURN: string = "turn_mp3";
    public static SND_UP: string = "up_mp3";
    public static SND_WARN: string = "warn_mp3";
    public static SND_WIN: string = "win_mp3";
    public static SND_XP: string = "xp_mp3";
    public static SND_BUY: string = "buy_mp3";

    public audioSpritesLoaded = false;

    constructor() {
        super();
        SoundService.instance.init(PathProvider.instance.getSoundURL("audiosprites.json"));
        SoundService.instance.addEventListener(SoundService.AUDIO_SPRITE_DONE, () => {
            this.audioSpritesLoaded = true;
        });
    }

    public playSoundEffectByName(nameString: string, loops: number = 0): SoundChannel {
        if (!this.audioSpritesLoaded) return;
        return super.playSoundEffectByName(nameString, loops);
    }

    public static soundByTableAction(action: number): string {
        switch (action) {
            case 3: return Poker2SoundController.SND_CALL;
            case 2: return Poker2SoundController.SND_CHECK;
            case 1: return Poker2SoundController.SND_FOLD;
            case 4: return Poker2SoundController.SND_RAISE;
            default:
                //6, 5, 0
                return Poker2SoundController.SND_RAISE;
        }
    }

}
